module.exports = __webpack_public_path__ + "static/media/efecte-itsm.68092cd0.png";